var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m119.308 377.692-108.324 108.325c14.645 14.645 38.388 14.645 53.033 0l81.808-81.808z",
    fill: "#077ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.803 464.803 81.808-81.808-31.82-31.82-81.808 81.808c-14.645 14.645-14.645 38.388 0 53.033 2.93 2.929 17.176-6.568 31.82-21.213z",
    fill: "#09a1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.688 334.525h45v63h-45z",
    fill: "#bfebff",
    transform: "matrix(.707 .707 -.707 .707 303.394 -.407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.475 313.312h45v63h-45z",
    fill: "#dff5ff",
    transform: "matrix(.707 .707 -.707 .707 282.181 8.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.431 393.602-21.213-21.213-21.213 21.213 21.213 21.213c5.858 5.858 15.355 5.858 21.213 0 5.858-5.857 5.858-15.355 0-21.213z",
    fill: "#a6cfe7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.218 393.602c5.858-5.858 5.858-15.355 0-21.213l-31.82-31.82c-5.858-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l31.82 31.82c5.857 5.858 15.355 5.858 21.213 0z",
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 202.5,
    fill: "#a6cfe7",
    r: 202.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.5 30v345c95.269 0 172.5-77.231 172.5-172.5s-77.231-172.5-172.5-172.5z",
    fill: "#dff5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 202.5c0-95.269-63.799-172.5-142.5-172.5-95.269 0-172.5 77.231-172.5 172.5s77.231 172.5 172.5 172.5c78.701 0 142.5-77.231 142.5-172.5z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchResults);
export default __webpack_public_path__ + "static/media/searchResults.6228e1e78f8bac2d41d49b7de272f785.svg";
export { ForwardRef as ReactComponent };